import React, { useEffect } from 'react'
import hclogo from "../images/hclogo.svg";
import download from "../images/download.png";
import { Link } from "react-router-dom";

const SuccessPage = () => {
    useEffect(() => {
		window.scrollTo(0, 0)
	}, [])
    return (
        <div className="flex justify-center md:py-12 md:px-12 lg:px-36 items-center min-h-screen bg-[#161515]">
            <div className="flex slide flex-col items-start  md:rounded-2xl shadow-xl py-10 md:py-20 px-7 md:px-10">
                <img src={hclogo} alt="hclogo" className="md:h-12" />
                <div className="my-4 flex flex-col justify-center items-center ">
                    <h2 className="text-3xl font-semibold text-white mb-4">
                        Congratulations!
                    </h2>
                    <p className="font-light creato text-[#D6D6D6]">
                        You have successfully registered for Haystack Conference 2026.
                    </p>
                    <img src={download} alt="" className="h-[320px]"  />
                    <p className="font-light creato text-[#D6D6D6]">
                        Want a quick assessment on your Knowledge about Missions ? Click the button below
                    </p>

                    <div className="flex flex-col items-center gap-4">
                        <Link
                            to='/survey'
                            className="transition-all bg-gradient-to-b from-[#5A5A5A] to-[#BBBBBB] text-white px-6 py-3 rounded-xl mt-6 ">
                            {/* {isDownloading? "Downloading..." : "Downlaod" } */} Let's Go!
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SuccessPage